(function ($) {
  "use strict";

  angular.module("fullyManagedApp")

      .controller("BlogListController", [
          "$scope", "$http", "$element", "$location", "$compile", "$parse", "$interpolate", function ($scope, $http, $element, $location, $compile, $parse, $interpolate) {

            $scope.keywords = '';

            $scope.items = [];
            $scope.isoItems = [];

            $scope.busy = false;
            $scope.pageSize = 10;
            $scope.totalItems = 0;
            $scope.isCleanSearch = true;

            $scope.canLoadMore = false;
            $scope.isNoResults = false;
            $scope.showTotalResults = false;
            $scope.currentCategoriesText = 'Show All';
            var _selectedCategoryNamesArr = [];


            var $resultsContainer = $('.results-container', $element);

            $scope.categories = [];

            var lastFilter = {};


            var handlerUrl = "/fm/blog/";

            var $tpmlString = $('#blog-card-template').html();

            $scope.init = function (pageSize, path, categoriesJson) {

              lastFilter.pageSize = pageSize;
              lastFilter.path = path;

              //categories
              $scope.categories.push({ value: "Show All", selected: true, isShowAll: true });

              var categories = angular.fromJson(categoriesJson);

              angular.forEach(categories, function (val, key) {
                val.selected = false;

                $scope.categories.push(val);
              });

              // init filters from url
              $scope.keywords = $location.search()["keywords"] || '';
              var categoriesString = $location.search()["categories"] || '';

              if (categoriesString.length > 0) {

                var filterCatArr = categoriesString.split('|');

                for (var i = 0; i < $scope.categories.length; i++) {


                  for (var j = 0; j < filterCatArr.length; j++) {


                    var categoryTitle = ($scope.categories[i].value || '').toLowerCase();
                    var categoryFilter = (filterCatArr[j] || '').toLowerCase();

                    if (categoryTitle.length > 0 && categoryTitle === categoryFilter) {
                      $scope.categories[i].selected = true;
                      $scope.categories[0].selected = false;
                    }
                  }
                }
              }

              //setup isotope
              $resultsContainer.isotope({
                itemSelector: '.result-card-item',
                //percentPosition: true,
                masonry: {
                  // set to the element
                  //columnWidth: '.grid-sizer'//,
                  columnWidth: 320,
                  gutter: 30,
                  fitWidth: true
                },
                sortBy: 'date',
                sortAscending: false,
                getSortData: {
                  date: function (itemElem, item) {
                  	return parseInt($(itemElem).attr('data-sort-date'));
                  }
                }

              });

              $scope.search();
            };

            $scope.categoryClicked = function (category) {

              if (category.isShowAll) {
                if (category.selected === false) {
                  category.selected = !category.selected;

                  for (var i = 1; i < $scope.categories.length; i++) {
                    $scope.categories[i].selected = false;
                  }
                }

              } else {
                category.selected = !category.selected;
              }

              var hasASelectedCategory = false;
              for (var i = 1; i < $scope.categories.length; i++) {

                if ($scope.categories[i].selected) {
                  hasASelectedCategory = true;
                  break;
                }
              }

              $scope.categories[0].selected = !hasASelectedCategory;

              $scope.search();
            };

            $scope.search = function () {
              if ($scope.busy)
                return;

              $scope.busy = true;

              setupFilter();
              setUrlHash();

              $http({
                method: 'POST',
                url: handlerUrl,
                data: angular.toJson(lastFilter),
                //headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                headers: { 'Content-Type': 'application/json' }
              }).then(function (data) {

                var jsonData = angular.fromJson(data.data);

                if (jsonData !== "undefined") {
                  if (jsonData.items) {
                    $scope.busy = false;

                    $scope.items = jsonData.items;

                    buildNewIsoItems(jsonData.items, true);

                    $scope.processFacets(jsonData.facets, jsonData.totalItems);

                    $resultsContainer.isotope();

                    $scope.totalItems = jsonData.totalItems;
                    $scope.canLoadMore = $scope.items.length < $scope.totalItems;
                    $scope.isNoResults = jsonData.totalItems == 0;
                    $scope.showTotalResults = true;
                  }
                }

              }, function (data, status, header, config) {
                $scope.busy = false;
                $scope.showTotalResults = true;
              });
            };

            $scope.loadMore = function () {
              if ($scope.busy)
                return;

              $scope.busy = true;

              lastFilter.offset = $scope.items.length;

              $http({
                method: 'POST',
                url: handlerUrl,
                data: angular.toJson(lastFilter),
                headers: { 'Content-Type': 'application/json' }
              }).then(function (data) {

                var jsonData = angular.fromJson(data.data);

                if (jsonData !== "undefined") {
                  if (jsonData.items) {
                    $scope.busy = false;
                    $scope.items = $.merge($scope.items, jsonData.items || []);

                    buildNewIsoItems(jsonData.items);

                    $scope.totalItems = jsonData.totalItems;
                    $scope.canLoadMore = $scope.items.length < $scope.totalItems;
                    $scope.isNoResults = jsonData.totalItems == 0;
                    $scope.showTotalResults = true;
                  }
                }

              }, function (data, status, header, config) {
                $scope.busy = false;
                $scope.showTotalResults = true;
              });

            };

            $scope.processFacets = function (facets, totalCount) {

              resetFacets($scope.categories);

              var filters = $scope.categories;

              filters[0].facetsCount = totalCount;

              angular.forEach(facets, function (facet) {

                if (filters != null) {
                  angular.forEach(filters, function (filter) {

                    if (filter.id === facet.Value) {
                      filter.facetsCount = facet.Count;

                      if (filter.facetsCount == 0) {
                        filter.isSelected = false;
                      }
                    }
                  });
                }

              });

            }

            function resetFacets(filters) {
              angular.forEach(filters, function (filter, index) {

                if (index > 0)
                  filter.facetsCount = 0;

              });
            }

            function setupFilter() {

              lastFilter.offset = 0;
              lastFilter.keywords = $scope.keywords;

              lastFilter.categories = [];

              _selectedCategoryNamesArr = [];

              if ($scope.categories[0].selected === false) {
                for (var i = 1; i < $scope.categories.length; i++) {

                  if ($scope.categories[i].selected) {
                    lastFilter.categories.push($scope.categories[i].id);

                    _selectedCategoryNamesArr.push($scope.categories[i].value);
                  }
                }
              }


              // rebuild $scope.currentCategories
              if (lastFilter.categories.length == 0) {
                $scope.currentCategoriesText = $scope.categories[0].value;
              } else {
                $scope.currentCategoriesText = _selectedCategoryNamesArr.join(', ');
              }

            }

            function setUrlHash() {

              $scope.isCleanSearch = true;
              // make sure setup filter was made first


              // start from scratch
              var searchParams = {};

              // check keywords
              if (lastFilter.keywords.length > 0) {
                searchParams.keywords = lastFilter.keywords;
                $scope.isCleanSearch = false;
              }

              // check categories
              if (_selectedCategoryNamesArr.length > 0) {
                searchParams.categories = _selectedCategoryNamesArr.join('|');
                $scope.isCleanSearch = false;
              }

              // set hash
              $location.search(searchParams);
            }

            function buildNewIsoItems(items, cleanUp) {

              if (cleanUp === true) {

                $resultsContainer.find('.result-card-item').each(function () {

                  var id = $(this).attr('data-id');

                  var exists = false;

                  for (var i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                      items[i].exists = true;
                      exists = true;
                      break;
                    }
                  }

                  if (!exists) {
                    $resultsContainer.isotope('remove', $(this));
                  }

                });
              }


              for (var i = 0; i < items.length; i++) {

                var item = items[i];

                if (items[i].exists !== true) {

                  var interpolated = $interpolate($tpmlString)(item);
                  //console.log(interpolated);

                  var $newItem = $($.trim(interpolated));

                  $resultsContainer.append($newItem).isotope("appended", $newItem);
                }
              }

              setTimeout(function () {

                $resultsContainer.find("[blogdotdotdot]").each(function () {
                  //$(this).dotdotdot();
                });
              }, 1000);

            }

            // caculate results container width in order to center align

            function setResultsContainerSize() {

              var cardWidth = 320;
              var gutterWidth = 30;

              $resultsContainer.css('width', 'auto');
              var containerWidth = $resultsContainer.width();

              var cardsCount = Math.floor((containerWidth + gutterWidth) / (cardWidth + gutterWidth));

              var requiredWidth = cardsCount * (cardWidth + gutterWidth) - gutterWidth;

              if (requiredWidth > containerWidth) {
                requiredWidth = requiredWidth - (cardWidth + gutterWidth);
              }

              $resultsContainer.css('width', requiredWidth);

            }

            setResultsContainerSize();

            $(window).resize(function () {
              setResultsContainerSize();
            });
          }
      ]);

})(jQuery);


// WEBPACK FOOTER //
// ./cmsscripts/custom/controllers/blogListController.js